export const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f4f7fb",
    padding: "30px 16px",
    fontFamily:'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  imageWrap: {
    marginTop: "16px",
    textAlign: "center",
  },
  questionImage: {
    maxWidth: "100%",
    maxHeight: "500px",
    borderRadius: "12px",
    border: "1px solid #ddd",
  },
  jumpBox: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    marginBottom: "10px",
  },

  jumpInput: {
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    fontSize: "15px",
    width: "140px",
  },
  container: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  mainTitle: {
    textAlign: "center",
    marginBottom: "24px",
    color: "#1f2937",
    fontSize: "32px",
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: "18px",
    padding: "24px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },
  sectionTitle: {
    margin: 0,
    fontSize: "24px",
    color: "#111827",
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  buttonGroupColumn: {
    display: "grid",
    gap: "14px",
    marginTop: "20px",
  },
  bigButton: {
    padding: "18px",
    fontSize: "18px",
    borderRadius: "14px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    fontWeight: "bold",
    textAlign: "left",
  },
  bankButton: {
    padding: "18px",
    fontSize: "16px",
    borderRadius: "14px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    textAlign: "left",
  },
  bankButtonTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#111827",
  },
  bankButtonSub: {
    marginTop: "6px",
    color: "#6b7280",
    fontSize: "14px",
  },
  quizPath: {
    color: "#6b7280",
    fontSize: "14px",
    marginBottom: "6px",
  },
  questionBox: {
    marginBottom: "20px",
    padding: "18px",
    backgroundColor: "#f9fafb",
    borderRadius: "14px",
  },
  questionText: {
    margin: 0,
    fontSize: "24px",
    lineHeight: 1.5,
    fontWeight: "bold",
    color: "#111827",
  },
  optionsWrap: {
    display: "grid",
    gap: "12px",
  },
  optionButton: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    width: "100%",
    padding: "16px",
    borderRadius: "12px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    textAlign: "left",
    fontSize: "16px",
  },
  optionLetter: {
    fontWeight: "bold",
    minWidth: "24px",
  },
  selectedOption: {
    border: "2px solid #2563eb",
    backgroundColor: "#eff6ff",
  },
  correctOption: {
    border: "2px solid #16a34a",
    backgroundColor: "#dcfce7",
  },
  wrongOption: {
    border: "2px solid #dc2626",
    backgroundColor: "#fee2e2",
  },
  feedbackBox: {
    marginTop: "20px",
    padding: "16px",
    borderRadius: "12px",
    border: "1px solid transparent",
    lineHeight: 1.7,
  },
  feedbackTitle: {
    fontWeight: "bold",
    fontSize: "18px",
    marginBottom: "8px",
  },
  correctFeedback: {
    backgroundColor: "#ecfdf5",
    borderColor: "#16a34a",
    color: "#166534",
  },
  wrongFeedback: {
    backgroundColor: "#fef2f2",
    borderColor: "#dc2626",
    color: "#991b1b",
  },
  navButtons: {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    marginTop: "24px",
  },
  primaryButton: {
    padding: "12px 20px",
    borderRadius: "10px",
    border: "none",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "15px",
  },
  secondaryButton: {
    padding: "12px 20px",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    color: "#111827",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "15px",
  },
  disabledButton: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  emptyBox: {
    marginTop: "18px",
    padding: "18px",
    borderRadius: "12px",
    backgroundColor: "#f9fafb",
    color: "#6b7280",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
  },
  accessBox: {
    marginTop: "20px",
    padding: "18px",
    borderRadius: "14px",
    backgroundColor: "#f9fafb",
    border: "1px solid #d1d5db",
  },

  accessTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "12px",
    color: "#111827",
  },

  accessInput: {
    width: "100%",
    maxWidth: "320px",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    fontSize: "15px",
  },

  accessError: {
    marginTop: "10px",
    color: "#dc2626",
    fontSize: "14px",
    fontWeight: "bold",
  },

  accessActions: {
    display: "flex",
    gap: "10px",
    marginTop: "14px",
  },

  toast: {
    position: "fixed",
    top: "20px",
    right: "20px",
    backgroundColor: "#16a34a",
    color: "white",
    padding: "12px 16px",
    borderRadius: "10px",
    fontWeight: "bold",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    zIndex: 999,
  },

  explainBox: {
    marginTop: "16px",
    padding: "16px",
    backgroundColor: "#f0fdf4",
    border: "1px solid #16a34a",
    borderRadius: "10px",
    lineHeight: 1.6,
  },

  explainText: {
    whiteSpace: "pre-wrap",
    lineHeight: 1.7,
  },

  loginPanel: {
    maxWidth: "420px",
    marginTop: "20px",
    marginBottom: "24px",
    padding: "22px",
    borderRadius: "16px",
    backgroundColor: "#f8fafc",
    border: "1px solid #e5e7eb",
  },

  loginTitle: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#111827",
    marginBottom: "6px",
  },

  loginSubtitle: {
    color: "#6b7280",
    marginBottom: "16px",
    lineHeight: 1.5,
  },

  loginInput: {
    width: "100%",
    boxSizing: "border-box",
    padding: "13px 14px",
    marginBottom: "12px",
    borderRadius: "10px",
    border: "1px solid #d1d5db",
    fontSize: "16px",
    backgroundColor: "#ffffff",
  },

  loginButton: {
    width: "100%",
    padding: "13px 18px",
    borderRadius: "10px",
    border: "none",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "16px",
  },

  adminBadge: {
    display: "inline-block",
    marginTop: "10px",
    marginBottom: "14px",
    padding: "6px 10px",
    borderRadius: "999px",
    backgroundColor: "#dcfce7",
    color: "#166534",
    fontWeight: "bold",
    fontSize: "14px",
  },

  linkButton: {
    marginTop: "12px",
    background: "none",
    border: "none",
    color: "#2563eb",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "15px",
    display: "block",
    padding: 0,
  },

  tableHeader: {
    textAlign: "left",
    padding: "12px",
    borderBottom: "1px solid #e5e7eb",
    backgroundColor: "#f9fafb",
    fontSize: "14px",
    color: "#374151",
  },

  tableCell: {
    padding: "12px",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "14px",
    color: "#111827",
  },

  smallPrimaryButton: {
    padding: "8px 12px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "13px",
  },

  smallSecondaryButton: {
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    color: "#111827",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "13px",
  },

  adminModuleGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    margin: "24px 0",
  },

  adminModuleButton: {
    padding: "18px",
    borderRadius: "14px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    color: "#111827",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "16px",
    textAlign: "left",
  },

  courseSection: {
    marginTop: "28px",
  },

  courseHeader: {
    marginBottom: "18px",
  },

  courseTitle: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#111827",
    marginBottom: "6px",
  },

  courseSubtitle: {
    fontSize: "16px",
    color: "#6b7280",
  },

  courseGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "18px",
  },

  courseCard: {
    padding: "24px",
    borderRadius: "20px",
    border: "1px solid #e5e7eb",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.08)",
  },

  courseBadge: {
    display: "inline-block",
    padding: "6px 10px",
    borderRadius: "999px",
    backgroundColor: "#dbeafe",
    color: "#1d4ed8",
    fontWeight: "bold",
    fontSize: "13px",
    marginBottom: "14px",
  },

  courseCardTitle: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#111827",
    marginBottom: "12px",
  },

  courseMeta: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    color: "#4b5563",
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "14px",
  },

  courseDescription: {
    color: "#4b5563",
    lineHeight: 1.6,
    marginBottom: "14px",
  },

  courseFeatureList: {
    paddingLeft: "0",
    listStyle: "none",
    marginBottom: "18px",
  },

  courseFeatureItem: {
    marginBottom: "8px",
    color: "#111827",
  },

  courseButton: {
    width: "100%",
    padding: "12px",
    borderRadius: "12px",
    border: "none",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "15px",
  },

  reviewGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
    gap: "12px",
    marginTop: "20px",
  },

  reviewQuestionButton: {
    padding: "14px",
    borderRadius: "12px",
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    fontWeight: "bold",
  },

  reviewAnswered: {
    backgroundColor: "#dcfce7",
    borderColor: "#16a34a",
  },

  reviewMarked: {
    backgroundColor: "#fef3c7",
    borderColor: "#f59e0b",
  },

  reportGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "14px",
    marginBottom: "18px",
  },

  reportCard: {
    padding: "18px",
    borderRadius: "14px",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
  },

  reportLabel: {
    color: "#6b7280",
    fontSize: "14px",
    marginBottom: "8px",
  },

  reportValue: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#111827",
  },

  resultQuestionCard: {
    padding: "14px",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    backgroundColor: "#ffffff",
  },

  resultCorrect: {
    backgroundColor: "#ecfdf5",
    borderColor: "#16a34a",
  },

  resultWrong: {
    backgroundColor: "#fef2f2",
    borderColor: "#dc2626",
  },

  reportValueSmall: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#111827",
    lineHeight: 1.4,
  },

  globalLanguageBar: {
    width: "100%",
    maxWidth: "1180px",
    margin: "0 auto 12px",
    padding: "16px 18px 0",
    boxSizing: "border-box",
  },
};